import { render, staticRenderFns } from "./AccountProfileEdit.vue?vue&type=template&id=296f0f4d&"
import script from "./AccountProfileEdit.vue?vue&type=script&lang=js&"
export * from "./AccountProfileEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports